import { render } from "./SegundoNome.vue?vue&type=template&id=5df80c96"
import script from "./SegundoNome.vue?vue&type=script&lang=js"
export * from "./SegundoNome.vue?vue&type=script&lang=js"
script.render = render

export default script